// src/services/emailsService.ts
import { apiClient } from './apiConfig';
import { EmailData } from '../types';

export const listEmails = async (): Promise<EmailData[]> => {
  const response = await apiClient.get<EmailData[]>('/emails');
  return response.data;
};

export const getEmail = async (id: string): Promise<EmailData> => {
  const response = await apiClient.get<EmailData>(`/emails/${id}`);
  return response.data;
};

export const createEmail = async (email: { email: string }): Promise<void> => {
  await apiClient.put('/emails', email );
};

export const updateEmail = async (id: string, email: Partial<EmailData>): Promise<void> => {
  await apiClient.put(`/emails/${id}`, email );
};

export const deleteEmail = async (id: string): Promise<void> => {
  await apiClient.delete(`/emails/${id}`);
};
